import _Object$entries from 'babel-runtime/core-js/object/entries';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { credentialsKey } from './api';
import { BrainmapsDataSource, productionInstance } from './frontend';
import { registerProvider } from '../default_provider';
registerProvider('brainmaps', options => new BrainmapsDataSource(productionInstance, options.credentialsManager.getCredentialsProvider(credentialsKey)));
if (typeof NEUROGLANCER_BRAINMAPS_SERVERS !== 'undefined') {
    for (const _ref of _Object$entries(NEUROGLANCER_BRAINMAPS_SERVERS)) {
        var _ref2 = _slicedToArray(_ref, 2);

        const key = _ref2[0];
        const instance = _ref2[1];

        registerProvider(`brainmaps-${key}`, options => new BrainmapsDataSource(instance, options.credentialsManager.getCredentialsProvider(credentialsKey)));
    }
}
//# sourceMappingURL=register_default.js.map